import { createFileRoute, redirect } from "@tanstack/react-router";
import { lastLayoutKey } from "@/components/items/ProductView";

/** /p/KEY opens the layout used last for this product (list by default). */
export const Route = createFileRoute("/_app/p/$productKey/")({
  beforeLoad: ({ params, search }) => {
    let layout = "list";
    try {
      layout = localStorage.getItem(lastLayoutKey(params.productKey.toUpperCase())) ?? "list";
    } catch {
      // private mode
    }
    throw redirect({
      to:
        layout === "board"
          ? "/p/$productKey/board"
          : layout === "timeline"
            ? "/p/$productKey/timeline"
            : "/p/$productKey/list",
      params: { productKey: params.productKey.toUpperCase() },
      search,
      replace: true,
    });
  },
});
